//MUI Components
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import PersonIcon from '@mui/icons-material/Person';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getPanier } from "../../../../store/selectors.js"; //global state : shopping state
import { panierSlice } from "../../../../store/panierSlice.js";

//Translate utils :
import { translator } from "../../../../utils/translator.js"
//import { useSelector, useDispatch } from "react-redux";
import { getLang } from "../../../../store/selectors.js"; //global state : shopping state
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

function TailleCycliste({ index, id_article }) { // component to manage the first step of shopping : choosing place and time

    let panier = useSelector(getPanier);
    const lang = useSelector(getLang) //global state : language
    const dispatch = useDispatch();

    function getCycliste() {
        let cycliste = {};
        let currentArticle = panier.filter((ligne) => ligne.id_article === id_article)
        if (currentArticle.length > 0) {
            cycliste.taille = currentArticle[0].tailles[index]
            cycliste.prenom = currentArticle[0].prenoms[index]
        }
        return cycliste
    }

    function handleChangeTaille(value) {
        //setTailleCycliste(value)
        dispatch(panierSlice.actions.updateTaille({ value, index, id_article }));
    }

    function handleChangePrenom(value) {
        //setTailleCycliste(value)
        dispatch(panierSlice.actions.updatePrenom({ value, index, id_article }));
    }

    function fillTailleSelect() {
        // add every object of the time list, to the select component
        let listTailles = [];
        listTailles.push(<MenuItem key={0} value={0}>-</MenuItem>);
        for (let i = 130; i < 220; i = i + 5) {
            listTailles.push(<MenuItem key={i} value={i}>{i + " cm"}</MenuItem>);
        }
        return listTailles;

    }


    return (
        <div className="ligne-taille-cycliste">
            <PersonIcon className="ligne-taille-cycliste-icon" />

            {/* <TextField
                value={getCycliste().taille}
                className="ligne-taille-cycliste-field1"
                label="Taille"
                type="number"
                InputLabelProps={{
                    shrink: true,
                }}
                size="small"
                sx={{ width: 130 }}
                onChange={(e) => handleChangeTaille(parseInt(e.target.value))}
            /> */}
            <FormControl className="ligne-taille-cycliste-field1">
                <InputLabel id="demo-simple-select-label">{translator("Taille", lang, "shoppingArticleTaille")}</InputLabel>
                <Select
                    className="ligne-taille-cycliste-field1-input"
                    labelId="demo-simple-select-label"
                    value={getCycliste().taille}
                    label={translator("Taille", lang, "shoppingArticleTaille")}
                    size="small"
                    /*  sx={{ width: 80 }} */
                    onChange={(e) => handleChangeTaille(e.target.value)}
                >
                    {fillTailleSelect()}
                </Select>
            </FormControl>

            <TextField
                value={getCycliste().prenom}
                className="ligne-taille-cycliste-field2"
                label={translator("Prénom", lang, "shoppingArticlePrenom")}
                size="small"
                InputLabelProps={{
                    shrink: true,
                }}
                onChange={(e) => handleChangePrenom(e.target.value)}
            />

        </div>

    )
}




export default TailleCycliste